module.exports = __webpack_public_path__ + "img/hospital.d0a19897.png";